import React, { useCallback, useEffect, useState } from "react";

import { getAllFields } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Col, MainPage, Row } from "components";

export const FieldList = () => {
  const [loading, setLoading] = useState(true);
  const [fields, setFields] = useState([]);
  const [page, setPage] = useState(0);
  const signal = useCancelAsyncOnUnmount()();

  const loadAllFields = useCallback(() => {
    getAllFields({
      page,
      signal,
    })
      .then((res) => {
        setFields((fields) => [...fields, ...res.fields]);

        if (res.count > page * 250 && res.count > 250) {
          setPage(page + 1);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, signal]);

  useEffect(() => {
    if (page > 0) {
      loadAllFields();
    }
  }, [loadAllFields, page]);

  useEffect(() => {
    loadAllFields();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${fields.length} fields`}
        description="View field details here. Deleting a field will permanently remove all data associated with it."
      />
      <Row>
        <Col>
          <AdminTable
            dataSource={fields}
            config={{
              actions: [
                {
                  icon: "tabler/eye",
                  route: "/farm/",
                  record: "farmId",
                  tooltip: "View this farm",
                },
              ],
              exclude: ["location"],
            }}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
